import type { FlightCardData } from '@massilia/queries'

import { FlightCard } from './flight-card'
import { FlightCardSkeleton } from './flight-card-skeleton'
import { offerCardKey, offerTransactionKey } from './offer-identity'

interface FlightListProps {
  isLoading?: boolean
  offers: FlightCardData[]
  onSelectFlight?: (flight: FlightCardData, selectedJourneyKeys: string[]) => void
  /** Transaction de repli, pour les offres antérieures au multiplexage bagage. */
  transactionKey: string
}

export function FlightList({ isLoading, offers, onSelectFlight, transactionKey }: FlightListProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <FlightCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (offers.length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-12 text-center">
        <div className="text-gray-600">
          <div className="mb-2 text-lg font-semibold">Aucun vol trouvé</div>
          <div className="text-sm">
            Essayez de modifier vos critères de recherche pour trouver des vols disponibles.
          </div>
        </div>
      </div>
    )
  }

  return (
    // 12px suffisent à séparer deux cartes qui portent déjà bordure et ombre ;
    // 16px, répétés sur une liste qu'on fait défiler, coûtaient une offre par écran.
    <div className="space-y-3">
      {offers.map((offer) => (
        // `offerId` seul ne suffit pas comme clé : il n'est unique que dans sa
        // transaction, et la liste en réunit deux (cf. `offerCardKey`).
        <div
          id={offer.debugId ? `offer-${offer.debugId}` : undefined}
          key={offerCardKey(offer, transactionKey)}
        >
          <FlightCard
            flight={offer}
            onSelect={onSelectFlight}
            // La liste réunit les offres de DEUX transactions Affidium (recherche
            // libre + recherche à bagage forcé) : le price s'interroge avec celle
            // de l'offre, pas avec celle de la réponse.
            transactionKey={offerTransactionKey(offer, transactionKey)}
          />
        </div>
      ))}
    </div>
  )
}
